module.exports = __webpack_public_path__ + "static/media/double-arrow.5f6554f6.svg";